<template>
  <div class="document">
    <h1>Conditions Générales d'Utilisation</h1>
    <p class="date">En vigueur au : Août 2026</p>

    <section>
      <h2>1. Objet</h2>
      <p>Les présentes Conditions Générales d'Utilisation (CGU) définissent les règles d'accès et d'utilisation de l'application web du GUC Voile en Isère.</p>
    </section>

    <section>
      <h2>2. Accès à l'Application</h2>
      <p>L'Application est accessible gratuitement à toute personne majeure ou mineure disposant d'un compte utilisateur.</p>
      <ul>
        <li>Les mineurs doivent obtenir l'accord d'un parent ou tuteur légal avant de créer un compte.</li>
        <li>Deux niveaux d'accès existent : Membres licenciés et Utilisateurs non licenciés</li>
        <li>L'Association se réserve le droit de suspendre ou supprimer tout compte en cas de violation des CGU.</li>
      </ul>
    </section>

    <section>
      <h2>3. Fonctionnalités</h2>
      <p>L'Application permet notamment :</p>
      <ul>
        <li>La consultation d'informations (covoiturage, ouvertures du local)</li>
        <li>L'adhésion en ligne et le paiement de cotisations via HelloAsso</li>
        <li>La réservation de matériel et de créneaux</li>
      </ul>
      <p>L'Association peut faire évoluer, suspendre ou interrompre ces fonctionnalités à tout moment.</p>
    </section>

    <section>
      <h2>4. Compte Utilisateur</h2>
      <p>La création d'un compte nécessite : nom, prénom, numéro de téléphone, date de naissance, genre et adresse email.</p>
      <p>L'utilisateur s'engage à fournir des informations exactes et à les tenir à jour. L'utilisateur est responsable de la confidentialité de ses identifiants.</p>
      <p>Les cotisations sont payées en ligne via HelloAsso. Aucun remboursement n'est effectué, sauf cas exceptionnel.</p>
    </section>

    <section>
      <h2>5. Droit à l'Image</h2>
      <p>Lors de l'inscription, l'utilisateur peut autoriser ou refuser l'utilisation de son image.</p>
    </section>

    <section>
      <h2>6. Propriété Intellectuelle</h2>
      <p>L'ensemble des contenus de l'Application (textes, logo, photos, etc.) est la propriété exclusive du GUC Voile.</p>
      <p>Les contenus partagés par les utilisateurs demeurent la propriété de l'Association une fois publiés.</p>
    </section>

    <section>
      <h2>7. Protection des Données (RGPD)</h2>
      <p>Les données collectées sont traitées pour la gestion des adhérents, des réservations, du covoiturage et des communications.</p>
      <p>Conformément au RGPD, vous disposez de droits d'accès, de rectification, d'effacement et d'opposition sur vos données.</p>
    </section>

    <section>
      <h2>8. Hébergement</h2>
      <p>L'Application est hébergée par OVHcloud.</p>
    </section>

    <section>
      <h2>9. Responsabilité</h2>
      <p>Chaque utilisateur reste seul responsable des informations qu'il publie et des échanges réalisés via les fonctionnalités.</p>
    </section>

    <section>
      <h2>10. Modifications</h2>
      <p>L'Association peut modifier ces CGU à tout moment. La poursuite de l'utilisation vaut acceptation des nouvelles CGU.</p>
    </section>

    <section>
      <h2>11. Droit Applicable</h2>
      <p>Les présentes CGU sont soumises au droit français. En cas de litige, compétence est attribuée aux tribunaux français.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ConditionsGenerales'
}
</script>

<style scoped>
.document {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

h1 {
  font-size: 28px;
  margin-bottom: 10px;
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
}

.date {
  color: #666;
  font-style: italic;
  margin-bottom: 30px;
  display: block;
}

section {
  margin-bottom: 25px;
}

h2 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

p {
  margin-bottom: 10px;
}

ul {
  margin-left: 20px;
  margin-bottom: 10px;
}

li {
  margin-bottom: 8px;
}
</style>